const DoctorOrConditionSelectorLanguage = {
	en: {
		placeholder: "condition, procedure or doctor name..."
	},
	es: {
		placeholder: "condición, procedimiento o nombre del médico ..."
	},
	ko: {
		placeholder: "antre kondisyon, pwosedi, non doktè ..."
	}
};
export default DoctorOrConditionSelectorLanguage;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-or-condition-selector/doctor-or-condition-selector.language.js